import _ from "lodash";
import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsChapterPageNavView from "scripts/views/contentDetailsChapterPageNavView";
import { getDownloadUrl } from "scripts/utils/mediaHelpers";

import templateContentDetailsChapterPage from "templates/contentDetailsChapterPage.hbs";

class ContentDetailsChapterPageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );

    this.initializeBookshelfDeps();
  }

  get template() {
    return templateContentDetailsChapterPage;
  }

  getTemplateData() {
    const user = this.securityService.getUser();

    const mediaModelData = this.mediaModel.toJSON();
    const parentContentData = mediaModelData.parentContent;

    const templateData = _.merge(mediaModelData, {
      showBuyLinks: user.getShowBuyLinks(),
      showShareLinks: user.getShowShareLinks(),
      showBadges: user.getShowBadges(),
      viewerUrl: `/viewer/${mediaModelData.id}`,
      parentMediaId: parentContentData ? parentContentData.mediaId : null,
      parentContentTitle: parentContentData ? parentContentData.title : null,
      thumbnailUrl: mediaModelData.parentContent
        ? mediaModelData.parentContent.thumbnailUrl
        : mediaModelData.thumbnailUrl,
      downloadUrl: getDownloadUrl(this.mediaModel),
    });

    return templateData;
  }

  render() {
    super.render();
    this.renderBookshelfElements();

    return this;
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsChapterPageNavView({
      model: this.model,
      organizationProperties,
    });
  }
}

export default ContentDetailsChapterPageView;
